import img1 from "../assets/images/CaseStudy1/img1.jpg";
import img2 from "../assets/images/CaseStudy1/img2.jpg";
import img3 from "../assets/images/CaseStudy1/img3.jpg";
import img4 from "../assets/images/CaseStudy2/img1.png";
import img5 from "../assets/images/CaseStudy2/img2.png";
import img6 from "../assets/images/CaseStudy2/img3.png";
import img7 from "../assets/images/CaseStudy3/img1.png";
import img8 from "../assets/images/CaseStudy3/img2.png";
import img9 from "../assets/images/CaseStudy3/img3.png";

export const caseStudies = [
  // {
  //   id: "1",
  //   title: "CRYSTAL BALL FORECASTING",
  //   content: [
  //     {
  //       type: "paragraph",
  //       url: "Inteliphyle Client Case Study - Growth Forecasting & Predictive Modelling",
  //     },
  //   ],
  //   footer:
  //     "Want to forecast your brand's growth using predictive sales modelling?  Connect with Inteliphyle today.",
  //   format: [
  //     {
  //       type: "video",
  //       url: "https://www.youtube.com/watch?v=x6s07R29aO0",
  //     },
  //   ],
  // },

  {
    id: "1",
    title: "Cracking the Growth Code: Forecasting with Precision",
    content: [
      {
        type: "paragraph",
        text: (
          <>
            <h4 style={{ color: "#ff6600" }}>
              MRSI Golden Key Awards 2024 Finalist
            </h4>
          </>
        ),
      },
      {
        type: "paragraph",
        text: "A global personal care leader sought to future-proof its business by anticipating business cycles and risks. They required a tool to accurately forecast brand sales and provide actionable insights for strategic planning.",
      },
      {
        type: "paragraph",
        text: (
          <>
            <h4>
              We proposed a predictive demand model using a structured, stepwise
              methodology:
            </h4>
          </>
        ),
      },
      {
        type: "paragraph",
        text: (
          <>
            <ol style={{ paddingLeft: "20px" }}>
              <li style={{ paddingTop: "5px" }}>
                <strong>Identifying Potential Variables affecting Sales</strong>
                <ul style={{ paddingLeft: "15px", paddingTop: "5px" }}>
                  <li>
                    Macro-economic and environmental factors (e.g. GDP,
                    inflation, weather, seasonality).
                  </li>
                  <li>
                    Company controllable factors (e.g. distribution, media,
                    pricing, promotions, SKU strategy etc).
                  </li>
                </ul>
              </li>

              <li style={{ paddingTop: "5px" }}>
                <strong>Data Integration</strong>
                <ul style={{ paddingLeft: "15px" }}>
                  <li>
                    Sourced and integrated <b>15 years</b> of historical data
                    for the potential variables from trusted sources like the
                    World Bank, IMF, Bangladesh Bureau of Statistics, and
                    client-provided datasets like Retail Audit, Household Panel,
                    Internal data etc.
                  </li>
                </ul>
              </li>

              <li style={{ paddingTop: "5px" }}>
                <strong>Advanced Analytics</strong>
                <ul style={{ paddingLeft: "15px" }}>
                  <li>
                    Evaluated <b>~200 variables</b> and{" "}
                    <b>4,700+ relationships</b> to develop{" "}
                    <b>3 causal models:</b> one for the category and two for
                    individual brands.
                  </li>
                  <li>
                    Employed time series design, multivariate modelling, and
                    regression techniques to ensure accuracy and causal
                    validity.
                  </li>
                </ul>
              </li>
            </ol>
          </>
        ),
      },
      {
        type: "image",
        url: img7,
      },
      {
        type: "paragraph",
        text: (
          <>
            <ol style={{ paddingLeft: "20px" }}>
              <li value={4} style={{ paddingTop: "5px" }}>
                <strong>Model Validation</strong>
                <ul style={{ paddingLeft: "15px" }}>
                  <li>
                    Achieved model fit of <b>0.8+</b> with{" "}
                    <b>+/- 3% accuracy</b> in forecasting quarterly sales,{" "}
                    <b>outperforming the global benchmark of +/- 9%.</b>
                  </li>
                </ul>
              </li>
            </ol>
          </>
        ),
      },
      {
        type: "image",
        url: img8,
      },
      {
        type: "image",
        url: img9,
      },
      {
        type: "paragraph",
        text: (
          <>
            <h3>The Business Impact:</h3>
          </>
        ),
      },
      {
        type: "paragraph",
        text: (
          <>
            <ul style={{ paddingLeft: "20px" }}>
              <li>Continuous quarterly sales forecasting</li>
              <li>
                Identifying the key business levers impacting sales and their
                size of impact.
              </li>
              <li>
                Business Plan Simulator for testing & optimizing input scenarios
                <ul style={{ paddingLeft: "15px" }}>
                  <li>To maximize sales</li>
                  <li>Facilitate optimal resourcing and budget planning</li>
                  <li>Setting ex-factory sales targets and planning inputs</li>
                </ul>
              </li>
            </ul>
          </>
        ),
      },
    ],
    footer:
      "Want to accurately forecast your brand's growth using predictive sales modelling? Connect with Inteliphyle today.",
    format: [
      {
        type: "markdown",
      },
    ],
  },

  {
    id: "2",
    title: "Breaking New Ground: Market Entry Strategy",
    content: [
      {
        type: "paragraph",
        text: "Winning in a new market isn't just luck — it is planning and strategy.",
      },
      {
        type: "paragraph",
        text: "Inteliphyle helped a multinational client cut through complexity, identifying where they had the Right to Play and the Right to Win.  We did this through gaining an in-depth understanding of the market via a 6-stage inter-connected multi-pronged approach.   Various facets of the market, the category and consumers were studied and evaluated.",
      },
      {
        type: "image",
        url: img1,
      },
      {
        type: "paragraph",
        text: "By conducting a comprehensive and in-depth 360-degree analysis with precision and rigor, we transformed uncertainty into a clear path to success.",
      },
      // {
      //   type: "image",
      //   url: img2,
      // },
      {
        type: "paragraph",
        text: "Forecasting market trends and analyzing key macro and micro growth drivers, we evaluated the complete market comprising 36 sub-categories. We used multiple layers of strategic assessment – which included the GROSI Index (Growth and Size Potential Index), future volumetric potential, market execution feasibility, consumer needs, and alignment with the client’s global strategy, and systematically refined the list from 35 to 24, then 16, and finally, to the 7 most promising categories.",
      },
      {
        type: "paragraph",
        text: "This meticulous approach combined advanced statistical modeling, social media analytics, and both primary and secondary research, ensuring precision and strategic clarity for the client’s decision-making.",
      },
      // {
      //   type: "image",
      //   url: img3,
      // },
      {
        type: "paragraph",
        text: (
          <>
            With a data-driven fusion of human expertise, machine learning, and
            AI, Inteliphyle uncovered a <b>half-a-billion-dollar opportunity</b>{" "}
            for the client. Armed with this insight, our client moved forward
            with confidence - ready to dominate new categories.
          </>
        ),
      },
    ],
    footer:
      "Want to unlock your next market win? Connect with Inteliphyle today.",
    format: [{ type: "markdown" }],
  },

  {
    id: "3",
    title: "Driving Brand Growth through Pull and Push Actions",
    content: [
      {
        type: "paragraph",
        text: "At Inteliphyle, we work closely with our clients to optimize their marketing activities and help their brands grow.  A case in point is the work carried out for a leading lifestyle player.",
      },
      {
        type: "paragraph",
        text: "Our client, a relatively new player in a well-penetrated category, was a challenger company with 4-5 brands in their portfolio.  To grow in this category, the client needed a deeper understanding of the individual brands in the category and arrive at a Playbook for driving holistic brand action and brand growth for its own brands.",
      },
      {
        type: "paragraph",
        text: "Brand growth requires a 360-degree push and pull strategy driven by marketing activities to create retailer and consumer interest.  An analysis of the push and pull architecture of the client’s portfolio, as well as competition brands, led to an understanding of the strengths and weaknesses of the various brands in their portfolio.",
      },
      {
        type: "paragraph",
        text: "Interestingly, the analysis uncovered the latent pull of the youngest brand in their portfolio (Client Brand A) that had the potential to grow at a significantly higher pace, if provided the right support.",
      },
      {
        type: "paragraph",
        text: "Client Brand A, despite being a new entrant in the market, was seen to show a promising trend on both pull and push metrics over time.",
      },
      {
        type: "image",
        url: img4,
      },
      {
        type: "paragraph",
        text: "The brand had a high pull among retailers and consumers.  However, it was not adequately supported on the push dimension. A deeper study of the client’s push and pull strategies using dispersion metrics identified opportunities for the brand and led us to make targeted recommendations around specific push dimensions that would propel the brand into the next level.  ",
      },
      {
        type: "image",
        url: img5,
      },
      {
        type: "paragraph",
        text: "Basis this market x brand level deep-dive modelling of each push-pull factor combination, specific actions were recommended at each market level.",
      },
      {
        type: "image",
        url: img6,
      },
      {
        type: "paragraph",
        text: "Implementation of the recommendations at the market level resulted in incremental market share growth for the brand in these markets, built the client’s confidence in the approach and led to similar work for other brands in their portfolio.  Today, this is an ongoing exercise for the client and provides marketing guidance to their teams to propel their brands forward in the most effective manner.",
      },
    ],
    footer:
      "Want to uncover the dormant stars in your portfolio? Connect with Inteliphyle today.",
    format: [{ type: "markdown" }],
  },
];
